module.exports = __webpack_public_path__ + "resources/img/btn-back@3x.b1181a9b.png";